'use client'

import { createContext, useContext } from 'react'
import type { CSVExportContextValue } from '~/utils/csv-export/types'

/**
 * CSV Export Context
 * Provides global state management for CSV exports across the application
 */
export const CSVExportContext = createContext<CSVExportContextValue | null>(null)

/**
 * Hook to access CSV Export context
 * @throws Error if used outside of CSVExportProvider
 */
export const useCSVExportContext = (): CSVExportContextValue => {
  const context = useContext(CSVExportContext)

  if (!context) {
    throw new Error('useCSVExportContext must be used within a CSVExportProvider')
  }

  return context
}

/**
 * Hook to check if CSV Export context is available
 * @returns boolean indicating if context is available
 */
export const useIsCSVExportContextAvailable = (): boolean => {
  const context = useContext(CSVExportContext)
  return context !== null
}
